<template>
  <div class="coupon-detail sm:px-40 m-auto">
    <div class="coupon-detail__header relative border-b border-grey-lighter mt-24 mb-16 pb-16">
      <div class="coupon-detail__header__row flex justify-between mb-8">
        <h5 class="header__title font-semibold">
          <template v-if="coupon.isSpecial">{{ $t('couponSpecial') }}</template>
          <template v-else>{{ coupon.name }}</template>
        </h5>
        <span class="title__price font-semibold text-blue-light text-lg flex-no-shrink leading-normal ml-16">
          <!-- <template v-if="coupon.discountUnit === 'price'">$ {{ coupon.discountValue | toCurrency }}
            <small>{{ coupon.currency }}</small>
          </template>
          <template v-if="coupon.discountUnit === 'percent'">{{ coupon.discountValue | toPercentage }}%</template> -->
          {{ displayCouponCount(coupon) }}
        </span>
      </div>
      <span v-if="coupon.expiryAt" class="title__date mt-8 text-sm text-grey-dark leading-normal">{{ $t('periodTo') }}
        {{ coupon.expiryAt | toDate('YYYY-MM-DD HH:mm:ss') }}</span>
    </div>
    <div class="coupon-detail__body">
      <div class="body__desc text-sm mb-40">
        <p class="leading-normal">{{ coupon.description }}</p>
      </div>
      <div class="body__limit mb-40">
        <h6 class="text-sm text-grey-dark leading-normal">{{ $t('useLimit') }}</h6>
        <p class="text-sm mt-8">{{ $t('fullConsumption')[0] }} {{ displayCouponMinDiscount(coupon) }} {{ $t('fullConsumption')[1] }}</p>
        <p v-if="coupon.discountUnit === 'percent' && coupon.maxDiscount > 0" class="text-sm mt-8">{{ $t('discountUpTo') }} {{ displayCouponMaxDiscount(coupon) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'

export default {
  name: 'couponDetail',
  props: {
    data: {
      type: [Object, Array]
    }
  },
  filters: {
    toPercentage: function (val) {
      return 100 - val * 100
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency'
    }),
    coupon () {
      return this.data.coupon
    },
    isCurrencyConvert: function () {
      return this.coupon.currency !== this.selectedCurrency
    }
  },
  methods: {
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
        if (this.isCurrencyConvert) {
          return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency })
        } else {
          return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency }))
        }
      }
    },
    displayCouponMinDiscount: function (coupon) {
      const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
      if (this.isCurrencyConvert) {
        return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.minPrice, { inputCurrency: coupon.currency })
      } else {
        return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.minPrice, { inputCurrency: coupon.currency }))
      }
    },
    displayCouponMaxDiscount: function (coupon) {
      const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
      if (this.isCurrencyConvert) {
        return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.maxDiscount, { inputCurrency: coupon.currency })
      } else {
        return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.maxDiscount, { inputCurrency: coupon.currency }))
      }
    }
  }
}
</script>

<style lang="sass" scope>

</style>
